import { createSlice } from "@reduxjs/toolkit";

import { AddressThunk } from "../Thunk/AddressThunk";

let initState = {
	reload: false,
	addressData: {},
};

let AddressReducer = createSlice({
	name: "Address",

	initialState: initState,
	reducers: {},
	extraReducers: (builder) => {
		builder

			.addCase(AddressThunk.pending, (state) => {
				state.reload = true;
			})
			.addCase(AddressThunk.fulfilled, (state, action) => {
				state.reload = false;
				state.addressData = action.payload.data;
			})
			.addCase(AddressThunk.rejected, (state, action) => {
				state.reload = false;
				state.error = action.error.message;
			});
	},
});
export default AddressReducer.reducer;
